import { ResponseDataTest } from "../../../models/responseDataTest";
import { agroApi } from "../api";
import { ResponseDataGet } from "../../../models/responseDataGet";
import { EntTransportCategory } from "../../../models/handBooks/transportCategory";
import { EntTransportCategoryFilter } from "../../../models/filters/transportCategoryFilter";
import { Paths } from "../../../paths";

export const transportCategoryApi = agroApi.injectEndpoints({
  endpoints: (builder) => ({
	getTransportCategoryList: builder.query<ResponseDataGet<EntTransportCategory>, EntTransportCategoryFilter>({
	  query: (filter) => ({
		url: `${Paths.handbooks.transportcategory}/get-all`,
		method: "POST",
		body: JSON.stringify(filter)
	  }),
	}),
	getTransportCategoryById: builder.query<ResponseDataTest<EntTransportCategory>, number>({
	  query: (id) => ({
		url: `${Paths.handbooks.transportcategory}/${ id }`,
		method: 'GET'
	  })
	}),
	addTransportCategory: builder.mutation<ResponseDataTest<EntTransportCategory>, EntTransportCategory>({
	  query: (body) => ({
		url: `${Paths.handbooks.transportcategory}`,
		method: "POST",
		body: JSON.stringify(body)
	  }),
	}),
	editTransportCategory: builder.mutation<ResponseDataTest<EntTransportCategory>, EntTransportCategory>({
	  query: (body,) => ({
		url: `${Paths.handbooks.transportcategory}`,
		method: 'PUT',
		body: JSON.stringify(body),
	  }),
	}),
	deleteTransportCategory: builder.mutation<ResponseDataTest<EntTransportCategory>, number>({
	  query: (id) => ({
		url: `${Paths.handbooks.transportcategory}/${ id }`,
		method: 'DELETE',
	  }),
	}),
  }),
  overrideExisting: false,
});

export const {
  useAddTransportCategoryMutation,
  useDeleteTransportCategoryMutation,
  useEditTransportCategoryMutation,
  useLazyGetTransportCategoryListQuery
} = transportCategoryApi;
